export const cancellationPlans = {
  1: 'easy',
  2: 'medium',
  3: 'hard',
}

export const dayTypesTranslate = {
  normalDay: 'روزهای عادی',
  peakDay: 'روزهای پیک',
  holiday: 'ایام نوروز',
}

export const cancellationTranslate = {
  easy: 'سهل گیرانه',
  medium: 'متعادل',
  hard: 'سخت گیرانه',
} as const
